export const NUMBER_OF_TOP_CARRIERS_TO_SHOW_IN_WIDGET = 4
